module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('h2', {
    staticClass: "cn",
    attrs: {
      "id": "_idParaDest-7"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  }), _c('a', {
    attrs: {
      "href": "#/text/9780062652874_Contents#r_idParaDest-7"
    }
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_21",
      "title": "21"
    }
  }, [_vm._v("Jax")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("As a Solani, Jax prided himself in knowing two things: how to fly absolutely anything, and how to stay out of trouble. The first was a breeze. He had a knack for flying, and when he closed his eyes he could feel the stars orbit around him no matter where he was, so he could never get lost.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The second, however, was proving to be a problem. Along with his "), _c('i', [_vm._v("excellent")]), _vm._v(" way-finding skills, he was taught at a young age to stay out of conflict. Solani were good at that: sticking to their heritage, never leaving their homes, growing old under the stars, and coasting under kingdom radar—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But being Ana’s getaway driver made staying out of trouble very, "), _c('i', [_vm._v("very ")]), _vm._v("difficult. Maybe he should have picked an easier job instead of being the most talented and respected pilot on the wrong side of the law.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Still, on days like this, he wondered if it was worth a lifetime in jail. Solani didn’t fare so well in dark places.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gunfire exploded through the alleyway below. He leaned "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_22",
      "title": "22"
    }
  }, [_vm._v("over the skysailer, squinting down into the mess of Nevaeh. Ana and D09 sprinted down the alleyway. A few yards behind, gaining speed, six of the kingdom’s mindless legion pursued them.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You were supposed to babysit her, metalhead, not send her into the middle of a firefight,” Jax muttered, tugging at his leather gloves—a nervous habit—and swooped into the no-fly airspace below.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sailer purred like a kitten, its silvery wings fanning up on either side of the hull, soaking in the solar light coming through the harbor high above them. Wind whistled through the cracks in the cockpit shield as he ducked out of the airstream, gliding toward Ana and her boyfriend—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Metal,")]), _vm._v(" he corrected himself. "), _c('i', [_vm._v("Metal ")]), _vm._v("boyfriend"), _c('i', [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Warning signals sprang up on his console. "), _c('i', [_vm._v("NO FLY. RETURN TO ROUTE.")]), _vm._v(" He swiped them away with a flick of his finger. If he was going to get arrested for anything, it wouldn’t be because he was flying in a "), _c('i', [_vm._v("no-fly zone")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In twenty yards the alleyway broke out into a crowded market square. Nervous sweat prickled the back of his neck; he only had one shot at this.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He unlatched the shield and shoved it up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ana! Di—"), _c('i', [_vm._v("Ak’va")]), _c('i', [_vm._v("!")]), _vm._v("” he cursed as a bullet ricocheted off the dash. He pushed on his goggles, his long silver ponytail swirling up like a streamer in the wind.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D09 grabbed Ana by the waist, skidded to a stop, and lifted his hand—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Jax jerked the helm left. The ship tilted sideways, diving "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_23",
      "title": "23"
    }
  }, [_vm._v("into the alley. The left wing scraped the ground, leaving a trail of sparks.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He outstretched his free hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen yards, ten—")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Di caught ahold of his arm, and as the ship burst into the market square, Jax used the momentum to swing them into the cockpit and right the ship. The sailer grazed over the top of the crowd, rising sharply, and burst out from between the buildings, higher and higher until the Messiers were dots with glowing blue eyes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ana scrambled to her feet, and grappled for the back of his chair. “We have to go after that skysailer! Did you see it? It’s—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I saw it,” Jax interrupted, looking up at the ship rising through the slipstreams of traffic. “And that means you "), _c('i', [_vm._v("don’t")]), _vm._v(" have the coordinates.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("D09 inspected his cut hood. “We ran into some problems.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("“Obviously.”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even if the Messiers got a good look at their skysailer, thanks to his paranoia it looked like every other standard-grade skysailer in the kingdom. Recognizable, but easy to mix up between his and the one in front of him in traffic.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Above them, the pinprick of the skysailer in question swirled up into the underbelly of one of the floating Ironblood gardens, and his heart sank. Anywhere else. The Ironblood could’ve gone literally "), _c('i', [_vm._v("anywhere ")]), _vm._v("else.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Love,” he said, easing back on the helm, “I think your Ironblood’s late to a party.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_24",
      "title": "24"
    }
  }, [_vm._v("Ana stared up at the floating patch of greenery. “That’s not . . .”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Astoria. The Valerios’ garden estate,” D09 confirmed. “Where the Grand Duchess is scheduled to announce her heir.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Well, we gave it our best,” Jax said lightly, turning the skysailer toward the harbor. “Who’s up for a round of Wicked Luck when we get ba—”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re going, Jax,” she said stonily.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Come again?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is not wise,” Di agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“See, when the Metal agrees with me, we have a problem,” he noted dryly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She glared at both of them. “Either we’re going or I’m kicking you both off this ship,” she threatened, the tone in her voice making his stomach twist like it did when he stared at the stars for too long.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He never liked that tone. It usually ended with them trapped in a mine on Cerces, or caught in the middle of a territory war between mercenaries. She wore trouble like royalty wore the Iron Crown, and it fit her a little too well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It’s the "), _c('i', [_vm._v("Valerios’ ")]), _vm._v("garden,” he stressed. “They’re worse than any mercenary group out there.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“We’re going,” she repeated.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He quickly looked away, chewing on the inside of his cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She went on, “And if I don’t get the coordinates this time, I’ll stop—I promise. Just give me one more chance.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He didn’t want to point out that if she got caught, there "), _c('span', {
    staticClass: "right_1",
    attrs: {
      "epub:type": "pagebreak",
      "id": "page_25",
      "title": "25"
    }
  }, [_vm._v("wouldn’t "), _c('i', [_vm._v("be ")]), _vm._v("a next time, but trying to argue with Ana was like trying to tell the stars to stop shining. Sighing, he pulled at his long, pale ponytail, trying to convince himself this was a good idea, and turned the ship up toward Astoria.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b5ff18e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/9780062652874_Chapter_4.vue
// module id = 81
// module chunks = 0